import React, { useEffect, useState, Fragment, useRef } from 'react'
import '../styling/containerStyles.css';
import { getBase } from './Functions/imageCompress';
import ButtonComp from '../components/button'
import Button from '@material-ui/core/Button';
import Label from '../components/label'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from "@material-ui/core/Typography";
import { handleImageUpload, handleDeleteImage } from './Functions/azureFile';


interface OnfidoPageptrProps {
    membershipID?: string;
    isOnfidoVerify?: Function;
    uploadDocumentIdfy?: any;
    docUploadLoading: boolean;
    getDocFile?: any;
    isDashboardFlag?: any;
    idfyDocData?: any;
    idfyTranStatus?: any;
    kycStatusFlag?: any;
    KycStatusAttempt?: any;
    setKycStatus: any;
    kycDocStatus?: any;
    selfieDocStatus?: any;
    isKycRequired?: boolean;
    setIsOnfidoPage?: any;
}


export const OnfidoPageptr: React.FC<OnfidoPageptrProps> = (props: OnfidoPageptrProps) => {

    const {
        uploadDocumentIdfy, docUploadLoading, getDocFile, isDashboardFlag, idfyDocData,
        kycStatusFlag, KycStatusAttempt, setKycStatus, kycDocStatus,selfieDocStatus, isKycRequired, setIsOnfidoPage
    } = props;

    const [isUpload, setIsUpload] = useState(false);
    const [isnotUploaded, setIsnotUploaded] = useState(idfyDocData.document_img ? false : true);
    const [fileData, setFileData] = useState(idfyDocData.document_img ? idfyDocData.document_img : {});
    const [message, setMessage] = useState('')
    const [imageProgress, setImageProgress] = useState(0);
    const [blobUrl, setBlobUrl] = useState<any>('');
    const [showNoFileChosen, setShowNoFileChosen] = useState(idfyDocData.document_img ? true : false); // Track if "No file chosen" is showing
    const fileInputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        getDocFile(fileData, isnotUploaded)
        setFileData(fileData)
    }, [])
    
    
    const getImgUploadProgess = (progress:any) => {
        setImageProgress(progress);
        if (progress < 100) {
            return;
        }
    }

    const uploadImage = async (fileArg: any) => {
        let fileData = fileArg.target.files[0]
        
        // if (idfyDocData.document_img) {
        //     await handleDeleteImage(idfyDocData.document_img);
        // }
        if (blobUrl) {
            await handleDeleteImage(blobUrl);
        }
        // Check if "No file chosen" is showing (when files.length === 0)
        const hasFile = (fileArg && fileArg.target && fileArg.target.files && fileArg.target.files.length > 0) || fileData;
        setShowNoFileChosen(!hasFile); // true when "No file chosen" is showing

        if (fileData != undefined) {
            setIsUpload(true);
            if (fileData.type == "image/jpeg" || fileData.type == "image/png") {
                let compressedFile = await getBase(fileData);
                // setFileData(compressedFile)

                
                const res = await handleImageUpload(compressedFile, getImgUploadProgess, "kyc");
                if (res && res[0] && res[0].normal_url) {
                    setBlobUrl(res[0].normal_url);
                    setFileData(res[0].normal_url);
                } else {
                    setFileData('');
                    setBlobUrl('');
                    setShowNoFileChosen(true); // Reset to show "No file chosen" if upload fails
                }

                setIsnotUploaded(false)
                getDocFile(res[0].normal_url, isnotUploaded)
                // getDocFile(compressedFile, isnotUploaded)
                setIsUpload(false); // D
                setKycStatus('');
            }
        }
    };

    const uploadDocument = async () => {
        if (idfyDocData.document_img) {
            await handleDeleteImage(idfyDocData.document_img);
        }
        await uploadDocumentIdfy(fileData)
    }
    
    return (
        <div className='doc-upload-main'>

            <div className='account_details'>
                <div className='buttonAndLabel'>
                    <Button className='goBack' ><ArrowBackIosIcon /></Button>
                    <Label content='Online KYC Verification' />
                </div>
                <br></br>
                <Fragment>
                    <div className="sideText">KYC document allowed (Aadhar card/Voter card/Driving licence) (Front side)</div>
                    <div style={{
                        display: 'block',
                        margin: '10px 0',
                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-end',
                        textAlign: 'left'
                    }}>
                    
                        {(imageProgress !== 0 && imageProgress < 100) && (
                            <div>
                                <CircularProgress size={34}/>
                                <Typography variant="caption" component="div" >
                                    {`${Math.round(imageProgress)}%`}
                                </Typography>
                            </div>
                        )}
                                                            
                        <input
                            ref={fileInputRef}
                            type="file"
                            className={showNoFileChosen ? 'hidetext' : 'showtext'}
                            name="documentImage"
                            disabled={isUpload || kycStatusFlag === "Approved" || kycStatusFlag === "Pending"}
                            id="fileupload"
                            onChange={e => {
                                uploadImage(e)
                            }}
                            accept="image/png, image/jpeg"
                        >
                        </input>

                        {idfyDocData.document_img ?
                            <Button className="download-kyc" onClick={() => {
                                window.open(idfyDocData.document_img)
                            }
                            }> Download </Button>
                            : null}
                    </div>

                    {
                        kycStatusFlag === "Pending" ?
                            <p style={{ color: "red", margin: '8px 0px 0px', display: 'flex' }}>
                                Kyc verification is in process, Please try again after sometime!
                            </p> :
                            kycStatusFlag === "Rejected" && (KycStatusAttempt < 3) ?
                                <p style={{ color: "red", margin: '8px 0px 0px', display: 'flex' }}>
                                    Your Kyc is rejected, Please try Again!
                                </p> :
                                kycStatusFlag === "Approved" ?
                                    <p style={{ color: "green", margin: '8px 0px 0px', display: 'flex' }}>
                                        Your kyc uploaded successfully
                                    </p> : null
                    }
                    {
                        kycDocStatus.status === false ?
                            <p style={{ color: "red", margin: '8px 0px 0px', display: 'flex' }}>
                                {kycDocStatus.message}
                            </p>
                            : selfieDocStatus.status === false ?
                                <p style={{ color: "red", margin: '8px 0px 0px', display: 'flex' }}>
                                    {selfieDocStatus.message}
                                </p>
                                : null
                    }
                    {message ?
                        <p style={{ color: "red", margin: '8px 0px 0px', display: 'flex' }}>
                            {message}
                        </p> : null
                    }
                    <ButtonComp label={'SUBMIT'}
                        name={'SUBMIT'}
                        visible={true}
                        disabled={!fileData || isUpload || isnotUploaded || docUploadLoading === true ? true : false || kycStatusFlag === "Pending" || kycStatusFlag === "Approved" || kycStatusFlag === "Rejected" || kycStatusFlag === null}
                        handleToUpdate={uploadDocument}
                    />
                    {!isKycRequired && (
                        <button className='skip-kyc-btn' onClick={() => setIsOnfidoPage(false)}>Skip KYC Verification</button>
                    )}
                </Fragment>
            </div>

        </div>
    )
}
export default OnfidoPageptr